import { isObject } from 'lodash';
import atob from '../helpers/atob';
export function parseRouterData(data) {
    try {
        return isObject(data) ? data : JSON.parse(data);
    }
    catch (e) {
        return JSON.parse(atob(data));
    }
}
